import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ElementRef,
  Inject,
  OnInit,
  Renderer2,
  SimpleChanges,
  ViewChild,
  ViewEncapsulation,
} from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { Router } from "@angular/router";
import { fuseAnimations } from "@fuse/animations";
import { HelperService } from "app/helpers/helper.service";

@Component({
  selector: "app-basic-member-details-dialog",
  templateUrl: "./basic-member-details-dialog.component.html",
  styleUrls: ["./basic-member-details-dialog.component.scss"],
  animations: fuseAnimations,
  encapsulation: ViewEncapsulation.None,
})
export class BasicMemberDetailsDialogComponent
  implements OnInit, AfterViewInit
{
  @ViewChild("extra_container", { read: ElementRef })
  extra_container: ElementRef;
  @ViewChild("footer", { read: ElementRef })
  footer_container: ElementRef;
  @ViewChild("sub_title", { read: ElementRef })
  sub_title: ElementRef;
  data: any = [];

  public afterViewInit = () => {};
  member_id: any;
  member_name: any;
  member_contact: any;

  constructor(
    public matDialogRef: MatDialogRef<BasicMemberDetailsDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public dialog_param: any,

    public renderer: Renderer2,
    private cdr: ChangeDetectorRef,
    private helper: HelperService,
    private router: Router
  ) {
    // this.data = dialog_param;
  }

  ngOnInit(): void {}
  ngAfterViewInit(): void {
    this.afterViewInit();
  }

  ngAfterViewChecked() {
    this.cdr.detectChanges();
  }

  onCardClick(): void {}

  ngOnChanges(changes: SimpleChanges): void {}

  setMemberData(data: any) {
    this.data = data;
    if (this.data[0].name != null || this.data[0].name != undefined) {
      this.member_name = this.data[0].name;
      this.member_contact = this.data[0].contact;
      if (this.data[0].hasOwnProperty("created_by")) {
        this.member_id = this.data[0].created_by;
      } else {
        this.member_id = this.data[0].member_id;
      }
    } else {
      this.member_name = this.data[0].member_name;
      this.member_id = this.data[0].member_id;
      this.member_contact = this.data[0].contact;
    }
  }

  memberView(member: any) {
    this.router.navigate(["/user/member_view", this.member_id]);
    this.matDialogRef.close();
  }
}
